import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useUIStore } from '../../../stores/useUIStore';
import { cn } from '../../../utils/cn';
import SidebarHeader from './SidebarHeader.jsx';
import SidebarNav from './SidebarNav.jsx';
import SidebarFooter from './SidebarFooter.jsx';

const Sidebar = () => {
    const { isSidebarOpen, toggleSidebar } = useUIStore();

    const sidebarVariants = {
        expanded: {
            width: 280,
            transition: {
                type: "spring",
                stiffness: 260,
                damping: 26,
                mass: 0.6,
                restDelta: 0.01
            }
        },
        collapsed: {
            width: 88,
            transition: {
                type: "spring",
                stiffness: 260,
                damping: 26,
                mass: 0.6,
                restDelta: 0.01
            }
        }
    };

    return (
        <motion.aside
            layout
            variants={sidebarVariants}
            initial={false}
            animate={isSidebarOpen ? "expanded" : "collapsed"}
            className={cn(
                "relative flex flex-col h-full bg-content1 border-r border-default-200"
            )}
        >
            {/* Background Texture/Gradient */}
            <div className="absolute inset-0 pointer-events-none overflow-hidden rounded-r-3xl">
                <div className="absolute top-0 left-0 w-full h-[500px] bg-gradient-to-b from-blue-500/5 via-purple-500/5 to-transparent opacity-50" />
                <div className="absolute -top-[200px] -left-[200px] w-[500px] h-[500px] bg-blue-400/10 rounded-full blur-3xl mix-blend-multiply filter" />
                <div className="absolute top-[20%] -right-[100px] w-[300px] h-[300px] bg-purple-400/10 rounded-full blur-3xl mix-blend-multiply filter" />

                {/* Glassmorphism Effect Enhancement */}
                <div className="absolute inset-0 bg-white/5 dark:bg-black/5 backdrop-filter backdrop-blur-[1px]" />
            </div>

            {/* Content */}
            <div className="relative z-10 flex flex-col h-full overflow-hidden">
                <SidebarHeader
                    collapsed={!isSidebarOpen}
                    toggleSidebar={toggleSidebar}
                />

                <SidebarNav
                    collapsed={!isSidebarOpen}
                />

                <SidebarFooter collapsed={!isSidebarOpen} />
            </div>
        </motion.aside>
    );
};

export default Sidebar;
